import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from '@mui/material';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { usePopoverState } from '@work4all/data/lib/hooks/usePopoverState';

import { CustomToolbarMappedAction } from '../../../../dataDisplay/actions-bar/ToolbarTypes';
import { Tooltip } from '../../../tooltip/Tooltip';

export type MoreMenuProps = {
  actions: CustomToolbarMappedAction[];
  buttonRef?: React.ForwardedRef<HTMLButtonElement>;
  className?: string;
};

export const MoreMenu = (props: MoreMenuProps) => {
  const { actions, buttonRef, className } = props;

  const innerRef = useRef(null);

  const { t } = useTranslation();

  const { handleClick, ...menuState } = usePopoverState('bottom');
  const { onClose: closeMenu } = menuState;

  const withAutoClose =
    (handler: React.MouseEventHandler<HTMLElement>) =>
    (event: React.MouseEvent<HTMLElement>) => {
      event.currentTarget = innerRef.current;
      handler?.(event);
      closeMenu();
    };

  return (
    <>
      <Tooltip title={t('MASK.MORE')} placement="top">
        <IconButton
          ref={buttonRef}
          size="medium"
          color="primary"
          className={className}
          onClick={(e) => {
            innerRef.current = e.currentTarget;
            handleClick(e);
          }}
        >
          <MoreVertIcon />
        </IconButton>
      </Tooltip>

      <Menu {...menuState}>
        {actions.map((action) => (
          <Tooltip
            key={action.actionKey}
            activateForDisabled
            title={
              action.disabled && action.disableReason
                ? action.disableReason
                : ''
            }
            placement="top"
          >
            <MenuItem
              disabled={action.disabled}
              onClick={action.href ? closeMenu : withAutoClose(action.onClick)}
              href={action.href}
              {...(action.href && { component: 'a' })}
              download={action.download}
              target={action.target}
            >
              <ListItemIcon
                sx={{
                  color: action.disabled ? 'var(--disabled)' : 'var(--brand01)',
                }}
              >
                {action.iconButton ?? (
                  <action.IconComponent
                    style={{ height: '1.5rem', width: '1.5rem' }}
                  />
                )}
              </ListItemIcon>
              <ListItemText color="green">{action.title}</ListItemText>
            </MenuItem>
          </Tooltip>
        ))}
      </Menu>
    </>
  );
};
